<script setup lang="ts">
const { open, empty } = defineProps<{
  empty: boolean
  open: boolean
}>()
defineEmits<{
  clear: []
}>()
defineSlots<{ default(): any }>()
</script>

<template>
  <button
    type="button"
    :class="[
      'flex items-center gap-2 rounded border px-3 py-2 text-xs font-medium leading-4	lg:text-md lg:leading-6',
      {
        'border-secondary-100 bg-secondary-100 text-secondary-400': !empty,
      },
      { 'border-gray-200 bg-white': !open && empty },
      { 'border-gray-700 bg-gray-100': open && empty },
    ]"
  >
    <slot />
    <BaseIcon
      v-if="!empty"
      :size="1"
      name="close"
      @click.stop="$emit('clear')"
    />
  </button>
</template>
